import { useDispatch, useSelector } from "react-redux";
import BasicCardDocumentos from "../../../pages/OtrosDocumentos/Components/BasicCardDocumentos";
import { ModalBase } from "../ModalBase";
import { State } from "../../../reducers";
import { generalModalConfirmEdit } from "../../../actions/general.actions";

export default function ModalConfirmEdicion (){
    const {modalEdit} = useSelector((state: State) => state.general)
    const dispatch  = useDispatch()
    const handleCloseModal = () => {
        dispatch(generalModalConfirmEdit({
            title: '',
            message: '',
            open: false,
            onConfirmEdit: null
        }))
    }

    const handleConfirm = () => {
        modalEdit.onConfirmEdit()
        handleCloseModal()
    }

    if(!modalEdit.open) return <></>

    return (
        <ModalBase>
            <BasicCardDocumentos title={modalEdit.title ? modalEdit.title : "Confirmar edición"}>
                <p style={{textAlign: 'center'}}>{modalEdit.message ? modalEdit.message : '¿Quieres confirmar este cambio? Esta acción no se puede deshacer.'}</p>
            <div style={{display: 'flex', gap: '20px'}}>
                <button onClick={handleCloseModal} className="button transparent">Cancelar</button>
                <button onClick={handleConfirm} className="button">Confirmar edición</button>
            </div>
            </BasicCardDocumentos>
        </ModalBase>
    )
}